import { render, staticRenderFns } from "./IconButtonCreate.vue?vue&type=template&id=03d1dacb"
import script from "./IconButtonCreate.vue?vue&type=script&lang=js"
export * from "./IconButtonCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports